<template>
  <content-panel style="margin: 0">
    <template v-slot:search>
      <!--搜索-->
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="70px" :model="searchForm" :rules="rules" ref="searchForm">
          <div class="search-row">
            <el-form-item label="文件名:" prop="employeeNo">
              <el-input v-model.trim="searchForm.folderName" placeholder="请输入文件名" @keyup.enter.native="onSearchList"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearchList">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="resetForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" class="green-btn" @click="uploadRecordsVisable = true">批量上传记录 </el-button>
        <el-button type="primary" size="mini" class="green-btn" @click="bacthoPeration(1)">下载 </el-button>
        <el-button type="warning" size="mini" @click="bacthoPeration">删除 </el-button>
      </template>
      <el-table
        @select="serlectRow"
        ref="tableRef"
        :height="maxTableHeight"
        border
        :data="tableData.records || []"
        :header-cell-style="{ backgroundColor: '#F4F8FB', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        style="width: 100%"
        v-loading="loading"
        @sort-change="handleSortChange"
        @selection-change="handleSelectionChange"
        :row-key="
          (row) => {
            return row.id;
          }
        "
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column label="预览" width="100">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.fileUrl"
              style="width: 79px; height: 52px"
              :src="scope.row.fileUrl"
              :preview-src-list="imgList"
              :initial-index="scope.$index"
              fit="cover"
            >
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="folderName" min-width="380" label="文件名">
          <template slot-scope="scope">
            <template v-if="scope.row.fileUrl">
              <el-link :underline="false" type="primary" @click="videoShow(scope.row, scope.$index)">{{ scope.row.folderName }}</el-link>
            </template>
            <template v-else>
              <el-link :underline="false" type="primary" @click="nextLayer(scope.row.id)">{{ scope.row.folderName }}</el-link>
            </template>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="updatedDate" label="上传时间" min-width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="name" label="上传人" min-width="80"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="type" label="类型" min-width="80">
          <template slot-scope="scope">{{ scope.row.type | typeText }}</template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="fileSize" label="大小" min-width="80"></el-table-column>
        <el-table-column label="操作" min-width="140" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" v-copy="scope.row.address" v-if="scope.row.address">复制地址</el-button>
            <el-button type="text" @click="rowDownLoad(scope.row)">下载</el-button>
            <el-button
              type="text"
              @click="del(scope.row)"
              v-permission="`ec-pc-new$pageMaterialManagement$filmRepairManagement$ProductShootingImageManagement$sectionDel`"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-footer height="auto" style="text-align: right; padding: 5px 0">
        <el-pagination
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="tableData.total"
        ></el-pagination>
      </el-footer>
    </table-panel>
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" v-if="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close
      ><imgShow :imgList="imgList" :imgIndex="imgIndex"></imgShow
    ></el-dialog>
    <!-- 批量上传记录 -->
    <upload-records :visible.sync="uploadRecordsVisable" :foldId="foldId" v-if="uploadRecordsVisable" />
  </content-panel>
</template>
<script>
import imgShow from './imgShow';
import uploadRecords from './uploadRecords';
import moment from 'moment';
import axios from '@/utils/axiosInstance';
import tableMixin from '@/utils/tableMixin';
import Tiff from 'tiff.js';
export default {
  name: 'fileManagement',
  components: { imgShow, uploadRecords },
  mixins: [tableMixin],
  data() {
    return {
      tableHeight: null,
      loading: true,
      loadingAll: false,
      titleName: '',
      showFlag: false,
      searchForm: {},
      rules: {},
      requestParam: {},
      imgFormVisible: false,
      uploadRecordsVisable: false,
      imgList: [],
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      model: [],
      maxHeight: 'auto',
      params: {
        headers: {
          'Content-Type': 'application/json;charset=utf-8', // 根据后台的接参数方式前端指定请求头
        },
      },
      radio: null,
      selectSpus: [],
      onRemoveSpuIds: [],
      queryCriteria: [],
      foldId: '',
      fliePath: '',
      errorNum: 0,
      tableRow: {},
      sortParams: {},
      searchFormData: {},
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
      imgIndex: 0,
    };
  },
  computed: {},
  methods: {
    serlectRow(i, v) {
      this.model = i;
    },
    handleSelectionChange(val) {
      this.onRemoveSpuIds = [];
      console.log('val', val);
      val.forEach((x) => {
        this.onRemoveSpuIds.push(x.id);
      });
      this.selectSpus = val;
    },
    onSearch(foldId) {
      this.$refs.tableRef.clearSelection();
      this.foldId = foldId || this.foldId;
      this.tableData.pageNum = 1;
      this.init();
    },
    async init(type) {
      this.loading = true;
      let data = {
        filterData: {
          id: this.foldId,
          fileName: this.searchForm.folderName,
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      this.$q.newProduct
        .getCurrentLevelFolderAndFile({ data: data })
        .then((res) => {
          this.tableData = res.data;
          this.imgList = res.data.records ? this.tableData.records.map((v) => v.fileUrl) : [];
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    videoShow(row, index) {
      this.imgFormVisible = true;
      this.imgIndex = index;
      console.log(index);
      // let name = row.fileUrl.match(/\.([^\.]+)$/)[1]
      // if(name == 'tif' || name == 'TIF') {
      //   this.getTiffDataUrlHandler(row.fileUrl);
      // }else{
      //   this.imgList = [row.fileUrl]
      // }
    },
    //针对于tiff格式处理展示
    async getTiffDataUrlHandler(url) {
      const response = await fetch(url);
      const buffer = await response.arrayBuffer();
      try {
        const tiff = new Tiff({ buffer: buffer });
        this.imgList = [tiff.toDataURL()];
      } catch (err) {
        this.getTiffDataUrlHandler(url);
      }
    },
    resetTableSort() {
      this.$refs.tableRef.clearSort();
    },
    onSearchList() {
      this.tableData.pageSize = 30;
      this.tableData.pageNum = 1;
      if (this.$refs.tableRef) {
        this.$refs.tableRef.clearSelection();
        this.$refs.tableRef.clearSort();
      }
      this.onSearch();
    },
    resetForm() {
      this.initSearchForm();
      this.onSearchList();
    },
    initSearchForm() {
      this.searchForm = {};
    },
    onSizeChange(pageSize) {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = pageSize;
      this.loading = true;
      this.init(this.searchFormData);
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.loading = true;
      this.init(this.searchFormData);
    },
    getCaption(obj) {
      var index = obj.lastIndexOf('.'); //获取-后边的字符串
      obj = obj.substring(index + 1, obj.length);
      return obj;
    },
    rowDownLoad(row) {
      if(row.type === 'folder') {
        this.sliceDownload(row)
      }else {
        this.downLoadRequest(row.fileUrl, row.folderName)
      }
    },
    downLoadRequest(fileUrl, folderName, index) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      setTimeout((_) => {
        this.downloadRes(fileUrl, folderName);
        loading.close();
      }, 300);
    },
    async downloadRes(url, folderName, type) {
      let response = await fetch(url, { mode: 'cors' });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = objectUrl;
      a.download = folderName +  (type ? '.zip' : '');
      a.click();
      a.remove();
      // if (this.selectSpus.length == index + 1) {
      //   setTimeout(() => {
      //     this.loadingAll.close();
      //   }, 500);
      // }
    },
    async bacthoPeration(type) {
      if (!this.selectSpus.length) {
        this.$message.error('请选择后在进行操作');
        return;
      }
      if (type == 1) {
        this.sliceDownload(false, true);
        //下载
      } else {
        //删除
        this.del(false, true);
      }
    },
    sliceDownload(row, type) {
      const _this = this;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      var data = type ? this.selectSpus : [row];
      data = data.map((v) => {
        return {
          fileId: v.type == 'file' ? v.id : '',
          folderId: v.type == 'folder' ? v.id : '',
          type: v.type,
        };
      });
      this.$q.newProduct.sliceDownload({ data: data }).then((res) => {
        // this.downloadRes(res.message,'产品拍摄图片管理-批量下载')
        var timer = setInterval(function () {
          _this.$q.common
            .reportTaskInfo({ fragment: [res.message] })
            .then((res) => {
              if (res.data.taskStatus == '执行完成') {
                clearInterval(timer);
                loading.close();
                _this.downloadRes(res.data.filePath, res.data.taskDesc, true);
              }
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        }, 5000);
      });
    },
    nextLayer(id) {
      this.$emit('expandNodeById', id);
      this.onSearch(id);
    },
    async del(row, type) {
      let status = await this.$confirm('确认删除当前文件？', '提示', { type: 'warning' });
      if (status !== 'confirm') return;
      var data = type ? this.selectSpus : [row];
      data = data.map((v) => {
        return {
          fileId: v.type == 'file' ? v.id : '',
          folderId: v.type == 'folder' ? v.id : '',
          type: v.type,
        };
      });
      this.$q.newProduct.sliceDelete({ data: data }).then((res) => {
        if (res.code == 200) {
          this.$message.success('删除成功');
          let type = !data.map((v) => v.type).includes('folder');
          this.$emit('getNewTree', this.foldId);
          this.onSearchList();
        }
      });
    },
    handleSortChange({ prop, order }) {
      this.sortParams = {
        type: order == 'ascending' ? 'asc' : order == 'descending' ? 'desc' : '',
        attributeName: prop,
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },

  mounted() {
    this.tableHeight = window.innerHeight - 220;
    // this.onSearch();
  },
  filters: {
    typeText(type) {
      if (type === 'folder') {
        return '文件夹';
      } else if (type === 'file') {
        return '文件';
      } else {
        return '';
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .content-panel {
  margin: 0 !important
}

>>> .el-dialog__headerbtn:hover .el-dialog__close{
  color: #FFF
}
</style>
